import { useState } from 'react'

import { albumCollectionByIdQuery } from '@/entities/album-collections'
import { type AuthorPreview } from '@/entities/authors'
import { StretchedTabs } from '@/shared/ui'
import { RoundedTabLabel } from '@/shared/ui'
import {
  CheckOutlined,
  PushpinOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { useUnit } from 'effector-react'
import { useLocation } from 'react-router-dom'

import { AlbumCollectionFormAlbums } from './ui/AlbumCollectionFormAlbums'
import { AlbumCollectionFormCommonInformation } from './ui/AlbumCollectionFormCommonInformation'

export {
  lastCreatedAlbumCollectionIdReset,
  $lastCreatedAlbumCollectionId,
  $albumCollectionCommonInformationFormInitialAuthor,
} from './model/album-collection-form-common-information.model'
export enum AlbumCollectionFormTabsKeys {
  CommonInformation = 'common_information',
  Albums = 'albums',
}

interface AlbumCollectionFormProps {
  onAuthorButtonClick: (callback: (id: string) => void) => void
}

export const AlbumCollectionForm = ({
  onAuthorButtonClick,
}: AlbumCollectionFormProps) => {
  const location = useLocation()
  const state = location.state as {
    activeTab?: AlbumCollectionFormTabsKeys
    author?: AuthorPreview
  }

  const [activeTabKey, setActiveTabKey] = useState(
    state?.activeTab ?? AlbumCollectionFormTabsKeys.CommonInformation,
  )

  const initialAuthor: AuthorPreview | undefined = state?.author

  const albumCollectionByIdQueryStatus = useUnit(
    albumCollectionByIdQuery.$status,
  )
  const creating = albumCollectionByIdQueryStatus === 'initial'

  return (
    <StretchedTabs
      activeKey={activeTabKey}
      onChange={(key: string) =>
        setActiveTabKey(key as AlbumCollectionFormTabsKeys)
      }
      items={[
        {
          key: AlbumCollectionFormTabsKeys.CommonInformation,
          label: (
            <RoundedTabLabel
              done={!creating}
              roundChildren={<UnorderedListOutlined />}
            >
              Общая информация
            </RoundedTabLabel>
          ),
          children: (
            <AlbumCollectionFormCommonInformation
              onAuthorButtonClick={onAuthorButtonClick}
              initialAuthor={initialAuthor}
            />
          ),
        },
        {
          key: AlbumCollectionFormTabsKeys.Albums,
          disabled: creating,
          label: (
            <RoundedTabLabel
              roundChildren={<PushpinOutlined />}
              disabled={creating}
            >
              Сезоны
            </RoundedTabLabel>
          ),
          children: <AlbumCollectionFormAlbums />,
        },
      ]}
    />
  )
}
